import { urlJoin } from 'url-join-ts';

import type { ListItem } from 'schema-dts';

interface BreadcrumbsItem {
    position: number;
    name: string;
    item: string;
}

export function generateBreadcrumbSchema(
    breadcrumbs: BreadcrumbsItem[],
    finalName: string,
    baseUrl = 'https://www.nocowanie.pl/',
) {
    const itemListElements: ListItem[] = breadcrumbs.map(crumb => ({
        '@type': 'ListItem',
        position: crumb.position,
        item: urlJoin(baseUrl, crumb.item, crumb.position !== 1 && '/'),
        name: crumb.name,
    }));

    itemListElements.push({
        '@type': 'ListItem',
        position: itemListElements.length + 1,
        name: finalName,
    });

    return {
        '@context': 'https://schema.org/',
        '@type': 'BreadcrumbList',
        itemListElement: itemListElements,
    };
}
